//export const API_VER = "";
let AOO_API_HOST;
let CONTENT_API_HOST;
AOO_API_HOST= process.env.REACT_APP_AOO_API_HOST;
CONTENT_API_HOST= process.env.REACT_APP_CONTENT_API_HOST;
//export const API_URL_OIDC =  process.env.REACT_APP_API_URL_OIDC;
export {AOO_API_HOST, CONTENT_API_HOST};


